import React from 'react';

import { Card, IconButton } from "@material-ui/core";
import PreferencesIcon from '../../../../img/preferences.svg';
import RecommendationsTipsDropdown from './RecommendationsTipsDropdown';
import BCLLoading from '../../../common/Loading/BCLLoading';
import BCLButton from '../../../common/Buttons/BCLButton';

import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';

import { LIKE, RECO_TYPE } from '../../../../constants/common';
import { Configuration } from '../../../../configs/Configuration';

export default class RecommendationsTips extends React.Component {
    render() {
        const props = this.props;
        const recoDetailsEnabled = props.configs['DASHBOARD.RECOMMENDATION_DETAILS_ENABLED'] === "true";
        const recoInsightsEnabled = props.configs["DASHBOARD.RECO_INSIGHTS_ENABLED"] === "true";
        const insightBulbImage = props.configs["DASHBOARD.RECOMMENDATIONS.INSIGHTS_BULB"];
        return (
            <>
                {props.recommendationsData.recoTipsToSaveEnergy && (
                    <p className="recommendations-title">
                        {props.translations["RECOMMENDATIONS.TIPS.TITLE"]}
                        <IconButton onClick={(e) => props.onToggleFilterDropdown(e)} classes={{root: "recommendations-filter-icon", label: "recommendations-filter-label"}} >
                            {props.translations["RECOMMENDATIONS.TIPS.SHOW_FILTERS"]} <img src={PreferencesIcon} alt="filter" />
                        </IconButton>
                    </p>
                )}

                <RecommendationsTipsDropdown recommendationsData={props.recommendationsData} translations={props.translations} appliancesList={props.appliancesList} configs={props.configs}
                    onToggleFilterDropdown={props.onToggleFilterDropdown} onApplianceCategoryCheckboxSelect={props.onApplianceCategoryCheckboxSelect} onApplyingFilters={props.onApplyingFilters} configColors={props.configColors}/>

                <div className="recommendations-tips-save-energy">
                    {props.recommendationsData.isLoading && <BCLLoading />}

                    {(props.recommendationsData.recoTipsToSaveEnergy) &&
                        (props.recommendationsData.recoTipsToSaveEnergy.length > 0 ?
                            (props.recommendationsData.recoTipsToSaveEnergy.map((item, index) => (
                                <Card className={"recommendations-tips-items" + (recoDetailsEnabled ? " clickable" : "") + (item.recommendationsMetaData.recommendationInsight ? " insight" : '')} key={index} 
                                onMouseEnter={() => props.onHoverRecos(item.recommendationsMetaData.primaryRecommendationId, RECO_TYPE.GRID)} 
                                onClick={(recoDetailsEnabled ? () => this.props.handleModal(item.recommendationsMetaData.primaryRecommendationId) : null)}>
                                    <div className="likes-container" onClick={(e)=> e.stopPropagation()}>
                                        { item.recommendationFeedback.response === LIKE ?
                                            <FavoriteIcon className="recommendations-likes" onClick={(e) => props.handleRecoLikeUnlike(index,e)} /> :
                                            <FavoriteBorderIcon className="recommendations-likes" onClick={(e) => props.handleRecoLikeUnlike(index,e)} />
                                        }
                                        {item.recommendationStatistics.countLike > 0 && (
                                            <>
                                                {item.recommendationStatistics.countLike} {item.recommendationStatistics.countLike > 1 ? props.translations["RECOMMENDATIONS.TIPS.LIKES"] : props.translations["RECOMMENDATIONS.TIPS.LIKE"]}
                                            </>
                                        )}
                                    </div>
                                    <div className="image-container">
                                        <img src={item.recommendationsMetaData.dashboardIcon} alt={item.recommendationsMetaData.title}/>
                                    </div>
                                    <div className="content-container">
                                        <p className="title">
                                            {item.recommendationsMetaData.title}
                                        </p>
                                        <p className="description">
                                            {item.recommendationsMetaData.description}
                                        </p>
                                    </div>
                                    {
                                            item.insight && recoInsightsEnabled &&
                                            <div className="reco-insight-container">
                                                <img src={insightBulbImage} alt=""/>
                                                <div className="insight">
                                                    {item.insight.insightText}
                                                </div>
                                            </div>
                                    }
                                </Card>
                            ))
                        ) : (
                            <p className="recommendations-unavailable">{props.translations["RECOMMENDATIONS.TIPS.UNAVAILABLE"]}</p>
                        )
                    )}

                    {props.recommendationsData.recoTipsToSaveEnergy && props.recommendationsData.recoTipsToSaveEnergy.length > 0 && props.recommendationsData.recoTipsToSaveEnergy.length < props.recommendationsData.recoTipsToSaveEnergyList.length && (
                         <BCLButton btnText={props.translations["RECOMMENDATIONS.SHOW_MORE"]} btnBackground={`rgb(${props.configColors['--color_25']})`} textColor={`rgb(${props.configColors['--color_54']})`}
                         hoverTextColor={`rgb(${props.configColors['--color_54']})`} hoverColor={`rgb(${props.configColors['--color_25']})`} borderColor="transparent" cssClassName="reco-show-more" onClick={() => props.showMoreRecos()} />
                    )}
                </div>
            </>
        )
    }
}
